import { render, staticRenderFns } from "./ModalRecetas.vue?vue&type=template&id=7d3c037c&scoped=true&"
import script from "./ModalRecetas.vue?vue&type=script&lang=js&"
export * from "./ModalRecetas.vue?vue&type=script&lang=js&"
import style0 from "./ModalRecetas.vue?vue&type=style&index=0&id=7d3c037c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3c037c",
  null
  
)

export default component.exports